import { useState, useEffect, useCallback } from 'react';
import { shallowEqual, useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import './Module4World.scss';
import '../../Animations.css';

import MediaService from '../../services/MediaService';
import { getVideo } from '../../s3Func/s3Download';

import Practice from './PosturePractice';
import Module4Config from './Module4Config';
import { getUserContent, sleep } from '../../utils';
import WorldContainer from '../../components/World/WorldContainer';

import monkeyEatingAnimation from './monkey_eating.gif';
import monkeyAnimationEnd from './monkey_closing.gif';

/**
 * Module1World is a base template for all worlds that follow it. In this case, this is for the
 * beach scene, but this code has been copied and pasted directly to worlds 1-5 with only slight
 * name changes to apply to each world. After world 5, there is an additional component of
 * Follow The Beat, which will have a comment writeup in Module6World.
 * @returns The HTML code for Module1World
 */
const Module4World = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { module4 } = useSelector((state) => state.module4, shallowEqual);
  const { login } = useSelector((state) => state.loginReducer, shallowEqual);
  const [slidesConfig, setSlidesConfig] = useState({});
  const [displayPracticeVideo, setDisplayPracticeVideo] = useState(false);
  const [showRewardSelection, setShowRewardSelection] = useState(false);

  // const [monkeyEatingAnimation, setMonkeyEatingAnimation] = useState("");
  const [monkeyEatingSound, setMonkeyEatingSound] = useState('');
  const [showEatingAnimation, setShowEatingAnimation] = useState(false);
  const [showEndAnimation, setShowEndAnimation] = useState(false);
  // const [monkeyAnimationEnd, setMonkeyAnimationEnd] = useState("");
  const [dayFinishedSound, setDayFinishedSound] = useState('');
  const [displayEndingVideo, setDisplayEndingVideo] = useState(false)

  const WORLD_IMAGES = {
    progressBar0: '/Module4Images/ProgressBanana0.png',
    progressBar1: '/Module4Images/ProgressBanana1.png',
    progressBar2: '/Module4Images/ProgressBanana2.png',
    progressBarCompleted: '/Module4Images/Reward_Banana.png',
    keyReward: '/Module4Images/Reward_Banana.png',

    gift: '/Images/Gift.png',

    animal: '/Module4Images/Monkey.png',
    worldBackground: '/newDesign/Unit1Module4/World4Large.png',
    pond: '/newDesign/Unit1Module4/World4Pond.png',
    logoutBtn: '/Module1Images/Logout.png',
    journeyImage: '/Module1Images/bluejourneymap.svg',
  };

  const WORLD_REWARDS = {
    Binoculars: '/Module4Images/Reward_Binoculars.png',
    Camera: '/Module4Images/Reward_Camera.png',
    Cheetah: '/Module4Images/Reward_Cheetah.png',
    DrumBlue: '/Module4Images/Reward_DrumBlue.png',
    DrumPink: '/Module4Images/Reward_DrumRed.png',
    Elephants: '/Module4Images/Reward_Elephant.png',
    Giraffe: '/Module4Images/Reward_Giraffe.png',
    JeepBlue: '/Module4Images/Reward_Car2.png',
    JeepPink: '/Module4Images/Reward_Car.png',
    Lion: '/Module4Images/Reward_Lion.png',
    Ostrich: '/Module4Images/Reward_Emu.png',
    Parrot: '/Module4Images/Reward_BirdColors.png',
    Tucan: '/Module4Images/Reward_Tucan.png',
    Zebras: '/Module4Images/Reward_Zebras.png',
    Hippo: '/Module4Images/Reward_Hippo.png',
    Flamingos: '/Module4Images/Reward_Flamingo.png',
  };

  const CHARACTER_REWARDS = {
    Hat: '/Module4Images/Reward_Hat.png',
    Bowtie: '/Module4Images/Reward_BowTie.png',
	}

  const POND_REWARDS ={
    Hippo: '/Module4Images/Reward_Hippo.png',
    Flamingos: '/Module4Images/Reward_Flamingo.png',
  }

  // Get AWS URL World Images
  Object.keys(WORLD_IMAGES).forEach((key) => {
    WORLD_IMAGES[key] = MediaService.getImage(WORLD_IMAGES[key], login);
  });

  // Get AWS URL Reward Images
  Object.keys(WORLD_REWARDS).forEach((key) => {
    WORLD_REWARDS[key] = MediaService.getImage(WORLD_REWARDS[key], login);
  });

  Object.keys(POND_REWARDS).forEach((key) => {
    POND_REWARDS[key] = MediaService.getImage(POND_REWARDS[key], login);
  });

  // Get AWS URL Reward Images
	Object.keys(CHARACTER_REWARDS).forEach((key) => {
		CHARACTER_REWARDS[key] = MediaService.getImage(
			CHARACTER_REWARDS[key],
			login
		)
	})

  const createPostureSlideShow = useCallback(async () => {
    const config = {
      navigate: '/posture',
      json: '',
      song: '',
      recording: '',
    };

    const { learn } = Module4Config[`day${module4.currentday}`];

    if (learn) {
      if (module4.currentday <= 4) {
        config.song = await getVideo(learn.song, login);
      } else {
        const userRecording = await getUserContent(
          learn.recording,
          module4.StudentID,
          login.influencerid,
					login
        );
        const song = await getUserContent(
          learn.song,
          module4.StudentID,
          login.influencerid,
					login
        );

        const demoSong = await getUserContent(
          learn.demoSong,
          module4.StudentID,
          login.influencerid,
					login
        );
        fetch(userRecording).then((response) => {
          if (response.status === 200) {
            config.recording = userRecording;
            config.song = song;
          }
          else{
            config.recording = null;
            config.song = demoSong;
          }

        })
      }

      config.json = learn.json;

      setSlidesConfig(config);
    }
  }, []);

  const handleFinalAnimationEnd = async () => {
    await sleep(500);

    dispatch({
      type: `MODULE4_SET_DAY_UNLOCK${module4.currentday + 1}`,
      payload: true,
    });

    dispatch({
      type: 'MODULE4_SET_dayCompleted',
      payload: module4.currentday,
    });

    if (module4.currentday !== 9) {
      dispatch({
        type: 'MODULE4_SET_stepCompleted',
        payload: 'notstarted',
      });
      await sleep(100);
			navigate('/posture/navigation')
		} else {
			setDisplayEndingVideo(true)
      setShowRewardSelection(false)
		}
  };

  const getMonkeyAnimation = async () => {
    /*
    const monkeyEatingGif = await getVideo(
      "appfiles/posture/monkey_eating.gif"
    );
    const monkeyEndAnimationGif = await getVideo(
      "appfiles/posture/monkey_closing.gif"
    );
    */

    const monkeyEatingData = await getVideo(
      'appfiles/posture/monkey_eating.mp3', login
    );

    const dayFinishedData = await getVideo('appfiles/posture/day_finished.mp3', login);

    /*
    setMonkeyEatingAnimation(monkeyEatingGif);
    setMonkeyAnimationEnd(monkeyEndAnimationGif);
    */
    setMonkeyEatingSound(monkeyEatingData);
    setDayFinishedSound(dayFinishedData);
  };

  useEffect(() => {
    createPostureSlideShow();
    getMonkeyAnimation();
  }, [module4.stepComplete, createPostureSlideShow]);

  const handleEatingAnimationEnd = () => {
    setShowEatingAnimation(false);
    setShowRewardSelection(true);
  };

  const rewardSelectionAnimation = async () => {
    const eatingAudio = new Audio(monkeyEatingSound);
    eatingAudio.play();
    await sleep(1000);
    setShowEatingAnimation(true);
    eatingAudio.onended = handleEatingAnimationEnd;
  };

  const handleFinalAnimation = async () => {
    setShowRewardSelection(false)
    setShowEndAnimation(true);
  };

  return (
    <>
      <WorldContainer
        name={"Posture"}
        module={module4}
        moduleName='MODULE4'
        moduleConfig={Module4Config}
        slidesConfig={slidesConfig}
        keyIcon={'banana-reward'}
        practice={
          <Practice
            setDisplayPractice={() => setDisplayPracticeVideo(false)}
            background={WORLD_IMAGES.worldBackground}
            stepComplete='MODULE4_SET_stepCompleted'
            module={module4}
          />
        }
        route='/posture'
        worldImages={WORLD_IMAGES}
        worldRewards={WORLD_REWARDS}
        showRewardSelection={showRewardSelection}
        uuid='posture'
        onPracticeClick={() => setDisplayPracticeVideo(true)}
        displayPracticeVideo={displayPracticeVideo}
        onRewardKeyClick={rewardSelectionAnimation}
        onRewardSelected={handleFinalAnimation}
        displayEndingVideo={displayEndingVideo}
      >
          <figure className="pond_rewards">
            <img className="pond" src={WORLD_IMAGES.pond} alt="pond" />
              {module4.rewards.Hippo && (
                <img
                  alt=""
                  src={POND_REWARDS.Hippo}
                  className="MODULE4 pond-rewards Hippo"
                />
              )}
              {module4.rewards.Flamingos && (
                <img
                  alt=""
                  src={POND_REWARDS.Flamingos}
                  className="MODULE4 pond-rewards Flamingos"
                />
              )}
          </figure>
          <div className='monkey-character'>
            <figure
              style={{
                height: !showEatingAnimation && !showEndAnimation ? 'auto' : 0,
                opacity: !showEatingAnimation && !showEndAnimation ? 1 : 0,
              }}
            >
              <img src={WORLD_IMAGES.animal} alt='monkey Icon' />
            </figure>

            <figure
              className='monkey-eating'
              style={{
                height: showEatingAnimation ? 'auto' : 0,
                opacity: showEatingAnimation ? 1 : 0,
              }}
            >
              <img src={monkeyEatingAnimation} alt='monkey eating animation' />
            </figure>

            {showEndAnimation && <figure
              className='monkey-closing'
            >
              <img 
                src={monkeyAnimationEnd} 
                alt='monkey end animation' 
                onLoad={()=>{  
                  const finalAnimationAudio = new Audio(dayFinishedSound);
                  finalAnimationAudio.play();
                  finalAnimationAudio.onended = handleFinalAnimationEnd;
                }}
              />
            </figure>}
            {module4.rewards.Hat && (
							<img
								alt=""
								src={CHARACTER_REWARDS.Hat}
								className="world-rewards MODULE4 character-rewards Hat"
							/>
						)}

						{module4.rewards.Bowtie && (
							<img
								alt=""
								src={CHARACTER_REWARDS.Bowtie}
								className="world-rewards MODULE4 character-rewards Bowtie"
							/>
						)}
          </div>
      </WorldContainer>
    </>
  );
};
export default Module4World;
